import React, { Suspense } from "react";
import PublicRoute from "./PublicRoute";
import { Navigate, Route, Routes } from "react-router";
import LazyLoader from "../components/common/commonComponents/LazyLoader/LazyLoader";
import { ToastContainer } from "react-toastify";

const Login = React.lazy(() => import("../components/common/Login/Login"));
const SetPassword = React.lazy(() => import("../components/common/SetPassword/SetPassword"));
const ResetPassword = React.lazy(() => import("../components/common/ResetPassword/ResetPassword"));
const ForgotPassword = React.lazy(() => import("../components/common/ForgotPassword/ForgotPassword"));

const PublicallyAccessibleRoutes = ({ props }) => {
  const { loader } = props;

  return (
    <div className="main_container">
      <Suspense fallback={<LazyLoader />}>
      <Routes>
        {/* Public Routes... */}
        <Route
          path="/"
          exact
          element={
            <PublicRoute>
              <Navigate replace to="/login" />
            </PublicRoute>
          }
        />
        <Route
          path="login"
          exact
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="resetPassword/:id/:value"
          exact
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="pmCreatePassword/:id"
          exact
          element={
            <PublicRoute>
              <SetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="createPassword/:id"
          exact
          element={
            <PublicRoute>
              <SetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="forgotPassword"
          exact
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />

        {/* default redirection - without auth no pvt should hit... */}
        <Route
          path="*"
          element={
            <PublicRoute>
              <Navigate replace to="/login" />
            </PublicRoute>
          }
        />
      </Routes>
      </Suspense>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default PublicallyAccessibleRoutes;
